









import Component from 'vue-class-component';
import {Mixins, Prop} from 'vue-property-decorator';
import InputMixin from '@/components/input/InputMixin';
import TextInput from '@/components/input/TextInput.vue';

@Component({
  components: {TextInput},
  mixins: [InputMixin]
})
export default class NumberInput extends Mixins<InputMixin>(InputMixin) {
  @Prop({default: true}) private readonly integer: boolean;
  @Prop({default: true}) private readonly showWordLimit: boolean;
  @Prop({default: -Infinity}) private readonly min: number;
  @Prop({default: Infinity}) private readonly max: number;

  get supplyShowWordLimit() {
    return this.showWordLimit;
  }

  public onChangeInput(data: any) {
    if (this.isReadOnly) {
      return;
    }

    // 순서 중요
    if (data === ' ') {
      return;
    }

    if (data === '') {
      this.commitValue(data);
      return;
    }

    if (isNaN(data)) {
      return;
    }

    let value = data;
    if (this.integer) {
      value = parseInt(data, 10);
    }

    if (isNaN(value)) {
      return;
    }

    this.commitValue(value);
  }

  protected onBlur($event: FocusEvent) {
    let value;
    if (this.integer) {
      value = parseInt(this.value, 10);
    } else {
      value = parseFloat(this.value);
    }

    if (isNaN(value)) {
      this.commitValue('');
      return;
    }

    if (value < this.min) {
      value = '';
    } else if (value > this.max) {
      value = '';
    }

    if (value.toString().length > this.maxLength) {
      value = value.toString().substr(0, this.maxLength);
    }

    this.commitValue(value);
  }

  protected onEnter($event: KeyboardEvent) {
    let value;
    if (this.integer) {
      value = parseInt(this.value, 10);
    } else {
      value = parseFloat(this.value);
    }

    if (isNaN(value)) {
      return;
    }

    if (value < this.min) {
      return;
    } else if (value > this.max) {
      return;
    }
    this.$emit('enter', $event);
  }

  public commitValue(value: any) {
    this.$emit('input', value);
    if (this.changeDetectable) {
      this.$store.commit('commitValue', {
        itemId: this.id,
        value,
        originValue: this.originValue
      });
    }
  }
}
